module.exports = __webpack_public_path__ + "static/media/Donald J. Trump - 2016.fa75d188.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Donald J. Trump - 2016.jpg
// module id = 455
// module chunks = 0